/**
 * RestScript options factory — single source for bootstrap registration and
 * one-off RestScript repository opens (e.g. product import reads).
 */

import type { RestScriptDataSourceOptions } from '@rammetec/data-access'
import { authFactory } from '@rammetec/data-access'
import { globalConfigService } from '@syscolect/application'
import { env } from '@/config/env'
import { restScriptGetAll } from './restScriptHandler'

/**
 * Builds RestScript data-source options (VectorHub host + getAll handlers).
 * Host is resolved lazily (env-first + Global Config fallback).
 */
export function buildRestScriptOptions(): RestScriptDataSourceOptions {
  const host = env.vectorhubApiHost ?? globalConfigService.getConfig()?.vectorhubApiHost
  if (!host || typeof host !== 'string') {
    throw new Error(
      '[restScriptOptions] VectorHub API host não configurado ' +
        '(defina VITE_VECTORHUB_API_HOST ou vectorhubApiHost no Global Config).',
    )
  }
  return {
    baseUrl: host,
    getToken: async () => {
      const authService = authFactory.getAuthService()
      return (await authService.getIdToken()) ?? null
    },
    applyClientQuery: false,
    handlers: {
      getAll: restScriptGetAll,
    },
  }
}
